/** Minimum horizontal travel before a viewer gesture changes pictures. */
export const PICTURE_SWIPE_MIN_PX = 48;

/**
 * Gallery the carousel should page through.
 * Overall Project and each Location stay separate.
 */
export function galleryContextForPicture(picture, { view, lockedLocationId, activeLocationId } = {}) {
  if (lockedLocationId) {
    return { kind: "location", locationId: lockedLocationId };
  }
  if (view === "location") {
    return { kind: "location", locationId: activeLocationId || picture?.location_id || "" };
  }
  if (view === "overall") {
    return { kind: "overall", locationId: "" };
  }
  if (picture?.location_id) {
    return { kind: "location", locationId: picture.location_id };
  }
  return { kind: "overall", locationId: "" };
}

export function picturesInGallery(pictures, context) {
  const rows = Array.isArray(pictures) ? pictures : [];
  if (!context || context.kind === "overall") {
    return rows.filter((row) => !row?.location_id);
  }
  return rows.filter((row) => row?.location_id === context.locationId);
}

export function carouselIndex(rows, pictureId) {
  const index = (rows || []).findIndex((row) => row?.picture_id === pictureId);
  return index < 0 ? 0 : index;
}

/** Stays on the first and last picture. */
export function stepCarousel(index, count, direction) {
  const total = Number(count) || 0;
  if (total <= 0) return 0;
  const current = Math.min(Math.max(Number(index) || 0, 0), total - 1);
  const next = current + direction;
  if (next < 0) return 0;
  if (next > total - 1) return total - 1;
  return next;
}

/**
 * 1 moves toward the next picture (swipe left).
 * -1 moves toward the previous picture (swipe right).
 * Vertical movement and short drags stay put.
 */
export function pictureSwipeDirection(start, end) {
  if (!start || !end) return 0;
  const dx = Number(end.x) - Number(start.x);
  const dy = Number(end.y) - Number(start.y);
  if (!Number.isFinite(dx) || !Number.isFinite(dy)) return 0;
  if (Math.abs(dx) < PICTURE_SWIPE_MIN_PX) return 0;
  if (Math.abs(dx) <= Math.abs(dy)) return 0;
  return dx < 0 ? 1 : -1;
}
